// Libs
import React, { useState } from "react";
import PropTypes from "prop-types";

// Contexts
import PageLoaderContext from "contexts/PageLoader";

function PageLoaderProvider({ children }) {
  const loaderState = useState(false);

  return <PageLoaderContext.Provider value={loaderState}>{children}</PageLoaderContext.Provider>;
}

PageLoaderProvider.propTypes = {
  children: PropTypes.node
};

export default PageLoaderProvider;
